import { render, staticRenderFns } from "./Adress.vue?vue&type=template&id=2ba25f72&scoped=true"
import script from "./Adress.vue?vue&type=script&lang=js"
export * from "./Adress.vue?vue&type=script&lang=js"
import style0 from "./Adress.vue?vue&type=style&index=0&id=2ba25f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba25f72",
  null
  
)

export default component.exports